import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-fake-radio-button',
  templateUrl: './fake-radio-button.component.html',
  styleUrls: ['./fake-radio-button.component.css']
})
export class FakeRadioButtonComponent implements OnInit {

  @Input() checked:boolean|any;

  constructor() { }

  ngOnInit() {
  }

}
